import * as moment from 'moment';

export class CalendarHelper {

    /**
     * This method returns an array of moments which represent the days that
     * should be shown in the calendar.
     *
     * If the number of dates in the month does not exactly fill the grid, then
     * the method will add days from the following month.
     *
     * @param startDate {moment.Moment}
     */
    static getDatesForMonth(
        startDate: moment.Moment
    ): Array<moment.Moment> {

        const m = startDate.month();
        let i = startDate
            .startOf('month')
            .startOf('day')
            .clone();

        const weekDay = i.weekday();

        const dates = [];

        // if startDate's day of the week is not Monday, we pull dates from
        // the previous month
        if (weekDay !== 1) {
            // loop over dates starting from the first Monday before startDate
            for (let h = weekDay - 1; h > 0; h--) {
                dates.push(i.clone().subtract(h, 'day'));
            }
        }

        // add all the dates from the month in the startDate
        while (i.month() === m) {
            dates.push(i.clone());
            i = i.add(1, 'day');
        }

        // we want a full grid, so calculate how many dates are missing
        const rows = Math.ceil(dates.length / 7);
        const missingCount = (rows * 7) - dates.length;

        for (let j = 0; j < missingCount; j++) {
            dates.push(i.clone());
            i = i.add(1, 'day');
        }

        return dates;
    }
}



// WEBPACK FOOTER //
// ./src/vas/pages/job-calendar/calendar.helper.ts